// Global Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Selectors
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
// @ts-ignore
import { selectCurrentSeasonId } from 'services/currentSeasonId/selectors';
// @ts-ignore
import { selectCurrentEntityId } from 'services/currentEntityId/selectors';
import { selectSprayEventTypeIsWeed } from 'services/sprayEventType/selectors';

import {
    selectFirstDate,
    selectLastDate
    // @ts-ignore
} from 'components/DatePagination/selectors';
import {
    selectDiaryFilterType,
    selectDiarySearchQueryString
} from './selectors';
import {
    PRODUCT_FILTER_TYPE,
    DATE_RANGE_FILTER_TYPE,
    EQUIPMENT_FILTER_TYPE,
    APPLICATION_RATE_FILTER_TYPE,
    ENTITIES_FILTER_TYPE,
    INNER_ENTITIES_FILTER_TYPE
} from './constants';

const selectDiaryFilter = createDeepEqualSelector(
    [
        selectDiaryFilterType,
        selectFirstDate,
        selectLastDate,
        selectDiarySearchQueryString
    ],
    (
        filterType,
        firstDateState: string,
        lastDateState: string,
        searchFilters
    ) => {
        const {
            sprayProductId,
            sprayEquipmentSetId,
            applicationRate,
            startDate,
            endDate,
            sprayEntityId,
            sprayInnerEntityId
        } = searchFilters;
        let filters: Array<Record<string, any>> = [];

        switch (filterType) {
            case PRODUCT_FILTER_TYPE:
                filters.push({ 'sprayEvent.sprayProducts.id': sprayProductId });
                break;
            case DATE_RANGE_FILTER_TYPE:
                filters = [
                    { startDate: { $gte: startDate } },
                    { startDate: { $lte: endDate } }
                ];
                break;
            case EQUIPMENT_FILTER_TYPE:
                filters.push({
                    'sprayEvent.sprayEquipmentSetId': sprayEquipmentSetId
                });
                break;
            case APPLICATION_RATE_FILTER_TYPE:
                filters.push({
                    'sprayEvent.applicationRate': applicationRate
                });
                break;
            case ENTITIES_FILTER_TYPE:
                filters.push({
                    entityId: sprayEntityId
                });
                break;
            case INNER_ENTITIES_FILTER_TYPE:
                filters.push({
                    'sprayEvent.sprayEntities.id': sprayInnerEntityId
                });
                break;
            default:
                filters = [
                    { startDate: { $gte: firstDateState } },
                    { startDate: { $lte: lastDateState } }
                ];
                break;
        }

        return filters;
    }
);

const selectLoadSprayEventsParams = createDeepEqualSelector(
    [
        selectCurrentOrganizationId,
        selectCurrentSeasonId,
        selectCurrentEntityId,
        selectSprayEventTypeIsWeed,
        selectDiaryFilter
    ],
    (
        currentOrganizationIdState: string | undefined,
        currentSeasonIdState: number | undefined,
        currentEntityIdState: number | undefined,
        sprayEventTypeWeed,
        diaryFilter
    ) => {
        return {
            organizationId: currentOrganizationIdState,
            filter: {
                eager: '[jobs.assignedUsers, sprayEvent.[sprayProducts, sprayEntities, sprayEventOperations]]',
                fields: ['sprayEvent.sprayEntities.id'],
                require: {
                    $and: [
                        {
                            'schema.eventTypeId': 'SPRAY',
                            'sprayEvent.isWeedSpray': sprayEventTypeWeed,
                            deletedAt: { $exists: false },
                            ...(currentSeasonIdState
                                ? { 'entity.seasonId': currentSeasonIdState }
                                : {}),
                            $and: [
                                ...diaryFilter,
                                ...(currentEntityIdState
                                    ? [
                                          {
                                              $or: [
                                                  {
                                                      'entity.path': {
                                                          $or: [
                                                              {
                                                                  $like: `/${currentEntityIdState}/%`
                                                              },
                                                              {
                                                                  $equals: `/${currentEntityIdState}`
                                                              }
                                                          ]
                                                      }
                                                  },
                                                  {
                                                      entityId:
                                                          currentEntityIdState
                                                  }
                                              ]
                                          }
                                      ]
                                    : [])
                            ]
                        }
                    ]
                },
                order: 'jobs.jobType asc'
            }
        };
    }
);

export { selectLoadSprayEventsParams, selectDiaryFilter };
